var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 11.2929C13.098 11.6839 13.098 12.3159 12.707 12.7069C12.512 12.9019 12.256 12.9999 12 12.9999C11.744 12.9999 11.488 12.9019 11.293 12.7069L10 11.4139L8.707 12.7069C8.512 12.9019 8.256 12.9999 8 12.9999C7.744 12.9999 7.488 12.9019 7.293 12.7069C6.902 12.3159 6.902 11.6839 7.293 11.2929L8.586 9.99991L7.293 8.70691C6.902 8.31591 6.902 7.68391 7.293 7.29291C7.684 6.90191 8.316 6.90191 8.707 7.29291L10 8.58591L11.293 7.29291C11.684 6.90191 12.316 6.90191 12.707 7.29291C13.098 7.68391 13.098 8.31591 12.707 8.70691L11.414 9.99991L12.707 11.2929ZM10 -9.15527e-05C4.486 -9.15527e-05 0 4.48591 0 9.99991C0 15.5139 4.486 19.9999 10 19.9999C15.514 19.9999 20 15.5139 20 9.99991C20 4.48591 15.514 -9.15527e-05 10 -9.15527e-05Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b87922eba3ceca7ca1f3f1f24af0e44f.svg";
export { ForwardRef as ReactComponent };